// extracted by mini-css-extract-plugin
export default {"page":"TtvtA","narrowContainer":"tpyY8 e2H7L","mainText":"dlpac","docs":"M4J_U"};